export default {
  dotia: {
    basic: {
      default: "#376bae",
      font: "#fff",
      darkMode: "#8cb7ef",
    },
    button: {
      default: "#376bae",
      font: "#fff",
      darkMode: "#8cb7ef",
    },
    backgrounds: {
      menu: "#333333",
      body: "#ececec",
    },
    soft_basic: {
      default: "#9bb5d6",
      dark: "#9bb5d6",
    },
    text_black: {
      default: "#202020",
      darkMode: "#ffffff",
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3",
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4",
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c",
    },
    light_black: {
      default: "#f2f2f2",
      dark: "#333",
    },
    white: {
      default: "#fff",
      darkMode: "#222",
    },
    hasFavicon: true,
    logo: "/static/img/brands/dotia/logo.svg",
    logocolor: "/static/img/brands/dotia/logo-color.svg",
    background: "/static/img/brands/dotia/background.jpg",
    logoSize: "big",
    instruccionesPropuestaPracticas: "",
    checkPerfil: true,
    hasMiPerfil: true,
    hasEncuestas: true,
    hasComunicaciones: true,
    canUploadDocPractica: true,
    dominioEncuesta: "https://portal-demoempleo.dev.doubledot.es/encuestas/",
    numTutoradosOevaluacionAsignadas: true,
    mensajeAntesEvaluar:
      "<p>Por favor, complete el cuestionario de finalización de prácticas para marcarla como cerrada.</p>",
    cantcerrarpractica: true,
    onlyShowCVinDocs: true,
    menunames: {
      validaciones: "Aceptaciones",
    },
    hideInMenu: {
      validaciones: {
        validadas: true,
        rechazadas: true,
      },
    },
    dashboardtexts: {
      validacion: "Prácticas pendientes de aceptación",
    },
    changevalidaciontoaceptacion: true,
    titulorechazo: "Por favor, indique el motivo de rechazo de la práctica",
    footer: {
      textos: ["", ""],
      links: {
        "Aviso Legal": "",
        "Política de Cookies": "",
      },
    },
    fonts: {
      link: "family=Roboto:300,400,700,800",
      principal: "'Roboto', sans-serif",
      secundaria: "'Roboto', sans-serif",
    },
    encabezados: {
      es: {
        validaciones: {
          idPractica: {
            nombre: "ID Práctica",
            visible: true,
          },
          nombreEstudiante: {
            nombre: "Nombre y apellidos",
            visible: true,
          },
          titulacion: {
            nombre: "Titulación",
            visible: true,
          },
          emailEstudiante: {
            nombre: "Email",
            visible: true,
          },
          puesto: {
            nombre: "Puesto",
            visible: true,
          },
          numDiasSemana: {
            nombre: "Nº días semana",
            visible: true,
          },
          nombreEmpresa: {
            nombre: "Nombre de empresa",
            visible: true,
          },
          sectorEmpresa: {
            nombre: "Sector de la empresa",
            visible: true,
          },
          mesesDuracion: {
            nombre: "Nº de meses",
            visible: true,
          },
        },
        tutorados: {
          idPractica: {
            nombre: "ID Práctica",
            visible: true,
          },
          nombreEstudiante: {
            nombre: "Nombre y apellidos",
            visible: true,
          },
          titulacion: {
            nombre: "Titulación",
            visible: true,
          },
          fechaInicio: {
            nombre: "Inicio",
            visible: true,
          },
          fechaFin: {
            nombre: "Fin",
            visible: true,
          },
          mesesDuracion: {
            nombre: "Nº de meses",
            visible: true,
          },
          puesto: {
            nombre: "Puesto",
            visible: true,
          },
          nombreEmpresa: {
            nombre: "Nombre de empresa",
            visible: true,
          },
          nombreGestorOferta: {
            nombre: "Nombre gestor Funge UVa",
            visible: true,
          },
        },
      },
    },
  },
};


// WEBPACK FOOTER //
// ./src/brands/brands.js